module.exports = __webpack_public_path__ + "img/group_icon.bf4f54e5.png";